export const signzyActions = [
  {
    name: 'createConsentRequest',
    label: 'Create Consent Request',
    args: [
      {
        name: 'userMobileField',
        label: 'Select User Phone Number Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'consentType',
        label: 'Select Consent Type',
        type: 'dropdown',
        optionsType: 'consentType',
        options: [
          { label: 'One Time', value: 'one_time' },
          { label: 'Periodic', value: 'periodic' },
        ],
        value: '',
      },
      {
        name: 'openInNewTab',
        label: 'Open Consent Page in New Tab',
        type: 'boolean',
        value: false,
      },
      {
        name: 'redirectUrl',
        label: 'Select Redirect Page After Consent is Given',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'fetchFinancialInformation',
    label: 'Fetch Financial Information',
    args: [
      {
        name: 'getRequestIdFrom',
        label: 'Get Request Id From',
        type: 'dropdown',
        optionsType: 'getRequestIdFrom',
        options: [
          { value: 'default', label: 'Current Item ID (Default).' },
          { value: 'loggedInUser', label: 'Request ID from Logged In User' },
        ],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'signzyDigitalDocSign',
    label: 'Digital Document Signing',
    args: [
      {
        name: 'pdfField',
        label: 'Select PDF Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'contractExecuterName',
        label: 'Contract Executer Name',
        type: 'text',
        value: '',
      },
      {
        name: 'contractTtl',
        label: 'Contract Expiry Time (in seconds)',
        type: 'number',
        value: '',
      },
      {
        name: 'signerNameField',
        label: 'Select Signer Name Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'signerGenderField',
        label: 'Select Signer Gender Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'uidField',
        label: 'Select UID Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'pinCodeField',
        label: 'Select Pin Code Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'yearOfBirthField',
        label: 'Select Year of Birth Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'signaturePosition',
        label: 'Select Signature Position',
        type: 'dropdown',
        optionsType: 'signaturePositionApi',
        options: [
          { value: 'TOPLEFT', label: 'Top Left' },
          { value: 'TOPCENTER', label: 'Top Center' },
          { value: 'TOPRIGHT', label: 'Top Right' },
          { value: 'MIDDLELEFT', label: 'Middle Left' },
          { value: 'MIDDLECENTER', label: 'Middle Center' },
          { value: 'MIDDLERIGHT', label: 'Middle Right' },
          { value: 'BOTTOMLEFT', label: 'Bottom Left' },
          { value: 'BOTTOMCENTER', label: 'Bottom Center' },
          { value: 'BOTTOMRIGHT', label: 'Bottom Right' },
        ],
        value: '',
      },
      {
        name: 'signaturePageNo',
        label: 'Signature Page No',
        type: 'text',
        value: '',
      },
      {
        name: 'openInNewTab',
        label: 'Open ESign Page in New Tab',
        type: 'boolean',
        value: false,
      },
      {
        name: 'successRedirectUrl',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'failureRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'fetchContractDetails',
    label: 'Fetch Contract Details',
    args: [
      {
        name: 'getContractIdFrom',
        label: 'Get Contract Id From',
        type: 'dropdown',
        optionsType: 'getContractIdFrom',
        options: [
          { value: 'default', label: 'Current Item ID (Default).' },
          { value: 'loggedInUser', label: 'Request ID from Logged In User' },
        ],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
];
